/** @jsx jsx */
import { jsx } from 'theme-ui'

import { Space } from './Space'

const Margin = props => <Space {...props} property="margin" />

export default Margin
